import { useState, useEffect } from "react";
import Modal from "react-bootstrap/Modal";
import { Button, Spinner } from "reactstrap";
import { APILA } from "../../../../../../config/apila";
import ToastSuccess from "../../../../../NotificationToast/ToastSuccess";
import ToastError from "../../../../../NotificationToast/ToastError";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faXmark, faTriangleExclamation } from "@fortawesome/free-solid-svg-icons";

export default function CancelNilai({ show, onHide, payload, onSuccess }) {
  const [loading, setLoading] = useState(false);
  const token = localStorage.getItem("token");

  useEffect(() => {
    if (!show) {
      setLoading(false);
    }
  }, [show]);

  const handleCancelApprove = async () => {
    setLoading(true);

    try {
      const res = await APILA.post(
        "/api/element-recaps-dimensi/cancel-approve-head",
        payload,
        {
          headers: {
            Authorization: `${token}`,
            "Content-Type": "application/json",
          },
        }
      );

      if (res?.status === 200) {
        ToastSuccess.fire({
          icon: "success",
          title: res.data.message || "Kunci nilai berhasil dibatalkan",
        });

        setLoading(false);      // ✅ RESET LOADING
        onHide();               // tutup modal
        onSuccess && onSuccess();
      }
    } catch (err) {
      ToastError.fire({
        icon: "error",
        title:
          err?.response?.data?.message || "Gagal membatalkan kunci nilai",
      });

      // ⬅️ balik ke modal konfirmasi
      setLoading(false);
    }
  };

  return (
    <Modal
      show={show}
      centered
      size="md"
      backdrop={loading ? "static" : true}
      keyboard={!loading}
      onHide={loading ? null : onHide}
    >
      {/* ================= HEADER ================= */}
      {!loading && (
        <>
          <div className="d-flex justify-content-end p-2">
            <FontAwesomeIcon
              icon={faXmark}
              style={{ cursor: "pointer" }}
              onClick={onHide}
            />
          </div>
          <hr />
        </>
      )}

      {/* ================= BODY ================= */}
      <Modal.Body className="text-center">
        {loading ? (
          /* ============ LOADING VIEW ============ */
          <div className="d-flex flex-column align-items-center" style={{padding: "80px  50px"}} >
            <Spinner color="warning" style={{ width: 50, height: 50 }} />
            <h6 className="mt-4 mb-1">Membatalkan kunci nilai</h6>
            <small className="text-muted mb-4">
              Mohon tunggu sebentar...
            </small>
          </div>
        ) : (
          /* ============ CONFIRM VIEW ============ */
          <>
            <FontAwesomeIcon
              icon={faTriangleExclamation}
              size="3x"
              className="mb-3"
              color="#f39c12"
            />

            <h5 className="mb-2">
              Batalkan Kunci Nilai di Seluruh Sekolah Ini?
            </h5>

            <p style={{ fontSize: "14px" }}>
              Nilai akan <b>dapat diedit kembali</b>.
            </p>
            <p> Apakah Anda yakin ingin membatalkan kunci nilai? </p>

            <div className="d-flex justify-content-center mt-4 mb-4">
              <Button color="secondary" style={{fontSize: "13px"}} className="mr-2" onClick={onHide}>
                Tidak
              </Button>

              <Button color="warning" style={{fontSize: "13px"}} onClick={handleCancelApprove}>
                Ya, Batalkan
              </Button>
            </div>
          </>
        )}
      </Modal.Body>
    </Modal>
  );
}
